function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { getImageUrl, AllImageSizes } from '@domain-group/fe-allhomes-library/lib/enums/image-size';
import { jsx as ___EmotionJSX } from "@emotion/core";
var singlePropertyPhotoPreviewWrapper = BaseListingDetails => {
  class SinglePropertyPhotoPreviewWrapper extends React.Component {
    constructor(props) {
      var _this, _this$props$property$3, _this$props$property$4;
      super(props);
      _this = this;
      _defineProperty(this, "buildPhotoItems", photos => photos.map((photo, index) => ({
        id: index,
        imageSrc: photo.imageSrc,
        order: photo.order || index,
        src: photo.mediaSrc || getImageUrl(photo.imageSrc, AllImageSizes.PHONE_SMALL),
        srcHighDef: getImageUrl(photo.imageSrc, AllImageSizes.HIGH_DEFINITION),
        srcThumb: getImageUrl(photo.imageSrc, AllImageSizes.SMALL),
        title: photo.title,
        type: photo.type
      })));
      _defineProperty(this, "openHistoryGallery", (photos, startIndex) => {
        this.props.onPropertyHistoryPhoto();
        this.setState({
          historyGalleryOpen: true,
          historyGalleryProps: {
            items: this.buildPhotoItems(photos),
            initialIndex: startIndex,
            onClose: () => {
              var _this$props$property$, _this$props$property$2;
              this.sortPhotos((_this$props$property$ = this.props.property.listing) === null || _this$props$property$ === void 0 ? void 0 : (_this$props$property$2 = _this$props$property$.media) === null || _this$props$property$2 === void 0 ? void 0 : _this$props$property$2.items);
              this.setState({
                historyGalleryOpen: false
              });
            }
          }
        });
        this.sortPhotos(photos);
        this.onPropertyHistorySlideChange({
          index: startIndex,
          expand: true
        });
      });
      // Sort supplied photos into groups, and keep an ordered list with all of them in gallery presentation order
      _defineProperty(this, "sortPhotos", items => {
        var photoItems = [];
        var floorPlanItems = [];
        var videoItems = [];
        var tourItems = [];
        items.forEach((item, index) => {
          switch (item.type) {
            case 'PHOTO':
              photoItems.push([index, item]);
              break;
            case 'FLOORPLAN':
              floorPlanItems.push([index, item]);
              break;
            case 'VIDEO':
              videoItems.push([index, item]);
              break;
            case 'VIRTUAL_TOUR':
              tourItems.push([index, item]);
              break;
            default:
              break;
          }
        });
        photoItems.sort((itemA, itemB) => itemA[1].order - itemB[1].order);
        var allItems = [...videoItems, ...tourItems, ...photoItems, ...floorPlanItems];
        this.sortedPhotoIndexRelation = allItems.map(item => item[0]);
        this.sortedPhotos = allItems.map(item => item[1]);
        this.photoItems = photoItems.map(item => item[1]);
        this.floorPlanItems = floorPlanItems.map(item => item[1]);
        this.videoItems = videoItems.map(item => item[1]);
        this.tourItems = tourItems.map(item => item[1]);
      });
      _defineProperty(this, "makeGalleryEventParameter", options => {
        var photo = this.sortedPhotos[options.index];
        return {
          index: this.getPhotoIndex(options.index),
          oldIndex: options.oldIndex ? this.getPhotoIndex(options.oldIndex) : undefined,
          expand: options.expand,
          type: photo.type,
          url: photo.mediaSrc || getImageUrl(photo.imageSrc, AllImageSizes.PHONE_SMALL),
          image: {
            id: this.getPhotoIndex(options.index)
          }
        };
      });
      _defineProperty(this, "onSlideChange", options => {
        this.props.onGalleryEvent(this.makeGalleryEventParameter(options));
      });
      _defineProperty(this, "onPropertyHistorySlideChange", options => {
        this.props.onPropertyHistoryGalleryEvent(this.makeGalleryEventParameter(options));
      });
      _defineProperty(this, "openGallery", function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          id: _this.sortedPhotos[0].id,
          index: 0,
          type: 'PHOTO',
          expand: true
        };
        _this.setState({
          carouselOpen: true,
          carouselIndex: options.index
        });
        _this.onSlideChange(options);
      });
      _defineProperty(this, "getPhotoIndex", displayedIndex => this.sortedPhotoIndexRelation[displayedIndex]);
      _defineProperty(this, "getOpenGalleryOptions", (index, oldIndex, expand) => {
        if (isEmpty(this.sortedPhotos)) {
          return {};
        }
        var photo = this.sortedPhotos[index];
        return {
          index,
          oldIndex,
          expand,
          id: photo.id,
          type: photo.type,
          url: photo.srcHighDef
        };
      });
      _defineProperty(this, "buildHeroPhotoPreviewProps", () => {
        var firstPhoto = this.videoItems.length + this.tourItems.length;
        var images = this.photoItems.map((photo, index) => ({
          id: index,
          title: photo.title,
          srcSmall: getImageUrl(photo.imageSrc, AllImageSizes.LARGE),
          srcMedium: getImageUrl(photo.imageSrc, AllImageSizes.PHONE_LARGE),
          srcLarge: getImageUrl(photo.imageSrc, AllImageSizes.PHONE_LARGE),
          srcExtraLarge: getImageUrl(photo.imageSrc, AllImageSizes.PHONE_LARGE),
          srcLowResolution: getImageUrl(photo.imageSrc, AllImageSizes.THUMBNAIL),
          onClick: () => {
            // Special case for first photo: view first available item (whether video, virtual tour, or image)
            var openItem = index === 0 ? 0 : firstPhoto + index;
            this.openGallery(this.getOpenGalleryOptions(openItem, null, true));
          }
        }));
        var heroPhotoPreviewProps = {
          images,
          onScrolledLeft: index => {
            this.props.onPreviewImageLeft(index, images[index].src, images[index]);
          },
          onScrolledRight: index => {
            this.props.onPreviewImageRight(index, images[index].src, images[index]);
          },
          onImageDisplayed: index => {
            this.props.onPreviewImageDisplayed(index, images[index]);
          },
          onClickGallery: () => {
            this.openGallery(this.getOpenGalleryOptions(0, null, true));
          },
          onClickFloorPlan: this.floorPlanItems.length > 0 ? () => {
            var index = firstPhoto + this.photoItems.length;
            this.openGallery(this.getOpenGalleryOptions(index, null, true));
          } : undefined,
          onClickVideo: this.videoItems.length > 0 ? () => {
            this.openGallery(this.getOpenGalleryOptions(0, null, true));
          } : undefined,
          onClickVirtualTour: this.tourItems.length > 0 ? () => this.tourItems[0].mediaSrc.startsWith('http://') ? this.openVirtualTour(this.videoItems.length, this.tourItems[0].mediaSrc) : this.openGallery(this.getOpenGalleryOptions(this.videoItems.length, null, true)) : undefined
        };
        return heroPhotoPreviewProps;
      });
      _defineProperty(this, "openVirtualTour", (index, url) => {
        this.props.onGalleryEvent({
          type: 'VIRTUAL_TOUR',
          index: this.getPhotoIndex(index),
          image: this.sortedPhotos[index]
        });
        var win = window.open(url, '_blank');
        win.opener = null;
      });
      _defineProperty(this, "getFirstImageUrl", () => {
        var photo = this.photoItems[0];
        if (photo) {
          return getImageUrl(photo.imageSrc, AllImageSizes.PHONE_MEDIUM);
        }
        return null;
      });
      _defineProperty(this, "buildPhotoCarouselProps", () => ({
        openHistoryGallery: this.openHistoryGallery,
        historyGalleryOpen: this.state.historyGalleryOpen,
        historyGalleryProps: this.state.historyGalleryProps,
        items: this.buildPhotoItems(this.sortedPhotos),
        initialIndex: this.state.carouselIndex,
        carouselOpen: this.state.carouselOpen,
        onClose: () => {
          this.setState({
            carouselOpen: false,
            carouselIndex: 0
          });
        },
        onSlideChange: (index, oldIndex) => {
          this.onSlideChange(this.getOpenGalleryOptions(index, oldIndex));
        },
        onSlideLeft: (index, oldIndex) => {
          var options = this.getOpenGalleryOptions(index, oldIndex);
          this.props.onGalleryLeftEvent(this.makeGalleryEventParameter(options));
        },
        onSlideRight: (index, oldIndex) => {
          var options = this.getOpenGalleryOptions(index, oldIndex);
          this.props.onGalleryRightEvent(this.makeGalleryEventParameter(options));
        },
        onSlideClick: index => {
          this.props.onGalleryClick(this.getOpenGalleryOptions(index));
        },
        onPropertyHistoryGalleryChange: (index, oldIndex) => {
          this.onPropertyHistorySlideChange(this.getOpenGalleryOptions(index, oldIndex));
        },
        onPropertyHistoryGalleryLeft: (index, oldIndex) => {
          var options = this.getOpenGalleryOptions(index, oldIndex);
          this.props.onPropertyHistoryGalleryLeftEvent(this.makeGalleryEventParameter(options));
        },
        onPropertyHistoryGalleryRight: (index, oldIndex) => {
          var options = this.getOpenGalleryOptions(index, oldIndex);
          this.props.onPropertyHistoryGalleryRightEvent(this.makeGalleryEventParameter(options));
        },
        onPropertyHistoryGalleryClick: index => {
          this.props.onPropertyHistoryGalleryClick(this.getOpenGalleryOptions(index));
        },
        firstImageUrl: this.getFirstImageUrl()
      }));
      _defineProperty(this, "addProps", () => _objectSpread(_objectSpread(_objectSpread({}, this.props), this.buildHeroPhotoPreviewProps()), this.buildPhotoCarouselProps()));
      this.state = {
        carouselOpen: false,
        carouselIndex: 0,
        historyGalleryOpen: false,
        historyGalleryProps: []
      };
      this.sortPhotos((_this$props$property$3 = this.props.property.listing) === null || _this$props$property$3 === void 0 ? void 0 : (_this$props$property$4 = _this$props$property$3.media) === null || _this$props$property$4 === void 0 ? void 0 : _this$props$property$4.items);
    }
    render() {
      return ___EmotionJSX(BaseListingDetails, this.addProps());
    }
  }
  SinglePropertyPhotoPreviewWrapper.propTypes = {
    onGalleryEvent: PropTypes.func,
    onGalleryLeftEvent: PropTypes.func,
    onGalleryRightEvent: PropTypes.func,
    onGalleryClick: PropTypes.func,
    onPropertyHistoryGalleryEvent: PropTypes.func,
    onPropertyHistoryGalleryLeftEvent: PropTypes.func,
    onPropertyHistoryGalleryRightEvent: PropTypes.func,
    onPropertyHistoryGalleryClick: PropTypes.func,
    onPreviewImageLeft: PropTypes.func,
    onPreviewImageRight: PropTypes.func,
    onPreviewImageDisplayed: PropTypes.func,
    openHistoryGallery: PropTypes.func,
    onPropertyHistoryPhoto: PropTypes.func,
    property: PropTypes.shape({
      listing: PropTypes.shape({
        media: PropTypes.shape({
          items: PropTypes.arrayOf(PropTypes.shape({}))
        })
      }),
      agents: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    printFriendlyLink: PropTypes.string
  };
  SinglePropertyPhotoPreviewWrapper.defaultProps = {
    onGalleryEvent: () => {},
    onGalleryLeftEvent: () => {},
    onGalleryRightEvent: () => {},
    onGalleryClick: () => {},
    onPropertyHistoryGalleryEvent: () => {},
    onPropertyHistoryGalleryLeftEvent: () => {},
    onPropertyHistoryGalleryRightEvent: () => {},
    onPropertyHistoryGalleryClick: () => {},
    onPreviewImageLeft: () => {},
    onPreviewImageRight: () => {},
    onPreviewImageDisplayed: () => {},
    openHistoryGallery: () => {},
    onPropertyHistoryPhoto: () => {},
    property: {},
    printFriendlyLink: ''
  };
  return SinglePropertyPhotoPreviewWrapper;
};
export default singlePropertyPhotoPreviewWrapper;